import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { DictionaryMaterialExploitation } from './models/material-exploitation';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryMaterialExploitationService
  extends StoreBaseService<DictionaryMaterialExploitation> {

  get entityType(): string {
    return EntityTypes.materialExploitation;
  }

  get resourceName(): string {
    return 'material-exploitation';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
